export default __webpack_public_path__ + "static/media/Minicard_Qd.f0bff8ee.svg";